import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading
  const [condo, setCondo] = useState(null);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("konddo_token");
    if (!token) { setUser(null); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCondo(data.condominium);
    } catch {
      localStorage.removeItem("konddo_token");
      setUser(null);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = (token, userObj) => {
    localStorage.setItem("konddo_token", token);
    setUser(userObj);
    loadMe();
  };

  const logout = () => {
    localStorage.removeItem("konddo_token");
    setUser(null);
    setCondo(null);
  };

  const updateUser = (patch) => setUser((u) => ({ ...u, ...patch }));

  return (
    <AuthContext.Provider value={{ user, condo, login, logout, refresh: loadMe, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
